
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#fff","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M6 2a1 1 0 011-1h2a1 1 0 011 1h3.5A1.5 1.5 0 0115 3.5v5a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 011 8.5v-5A1.5 1.5 0 012.5 2H6zm9 7.5v3a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 011 12.5v-3A1.5 1.5 0 002.5 11h11A1.5 1.5 0 0015 9.5zm-7.5-2a.75.75 0 000 1.5h1a.75.75 0 000-1.5h-1z"}})])
          )
        }
      }
    